// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\core\Enums\DateTemplate
// Generated on: 2025-10-12 12:23:50

export enum DateTemplate {
  TODAY = '{{todaysDate}}',
  YESTERDAY = '{{yesterday}}',
  LAST_7_DAYS = '{{last7Days}}',
  LAST_30_DAYS = '{{last30Days}}',
  LAST_6_MONTHS = '{{last6Months}}',
  LAST_YEAR = '{{lastYear}}',
  START_OF_MONTH = '{{startOfMonth}}',
  START_OF_YEAR = '{{startOfYear}}',
  END_OF_MONTH = '{{endOfMonth}}',
  END_OF_YEAR = '{{endOfYear}}',
}

export const DateTemplateCases = ["{{todaysDate}}", "{{yesterday}}", "{{last7Days}}", "{{last30Days}}", "{{last6Months}}", "{{lastYear}}", "{{startOfMonth}}", "{{startOfYear}}", "{{endOfMonth}}", "{{endOfYear}}"] as const;

